<template>
  <div class="index-introduce">
    <comTop></comTop>
    <banner></banner>
    <div class="introduceCer_box_total">
      <div class="introduceCer_box_top">
          <el-row class="img_box">
            <el-col><span class="span1">业务介绍</span></el-col>
            <el-col><span class="span2">Business Introduction</span></el-col>
            <el-col><div class="span3"></div></el-col>
            <el-col class="span4"><img src="../../assets/img/1.png" alt=""></el-col>
            <el-col class="span5">
              <el-row>
                <el-col><span class="span6">01</span></el-col>
                <el-col><span class="span7">&nbsp;|</span></el-col>
                <el-col><span class="span8">什么是AMC？</span></el-col>
                <el-col><span class="span9">AMC（Asset management companies）即资产管理公司。凡是主要从事此类业务的机构或组织都可以称为资产管理公司（Asset management companies）。</span></el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>  
        <div class="introduceCer_box_top">
          <el-row class="img_box">
            <el-col class="span4"><img src="../../assets/img/2.png" alt=""></el-col>
            <el-col class="span5">
              <el-row>
                <el-col><span class="span6">02</span></el-col>
                <el-col><span class="span7">&nbsp;|</span></el-col>
                <el-col><span class="span8">AMC的作用！</span></el-col>
                <el-col><span class="span9">AMC（Asset management companies）即资产管理公司。凡是主要从事此类业务的机构或组织都可以称为资产管理公司（Asset management companies）。</span></el-col>
              </el-row>
            </el-col>
          </el-row>
        </div> 
        <div class="introduceCer_box_top">
          <el-row class="img_box">
            <el-col class="span4"><img src="../../assets/img/3.png" alt=""></el-col>
            <el-col class="span5">
              <el-row>
                <el-col><span class="span6">03</span></el-col>
                <el-col><span class="span7">&nbsp;|</span></el-col>
                <el-col><span class="span8">扬海资产的职责</span></el-col>
                <el-col><span class="span9">AMC（Asset management companies）即资产管理公司。凡是主要从事此类业务的机构或组织都可以称为资产管理公司（Asset management companies）。</span></el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>  
        <comFooterMobile></comFooterMobile>
    </div> 
    <!-- <div class="introduceTop">
      <el-row>
        <el-col :span="8">
          <div class="login-logos">
            <img src="../../assets/img/img-logo.png" alt />
          </div>
        </el-col>
        <el-col :span="8" class="menu_left_in">
          <el-menu :default-active="$route.path" router class="el-menu-demo_in" mode="horizontal">
            <el-menu-item index="/index">首页</el-menu-item>
            <el-menu-item index="/introduce">业务介绍</el-menu-item>
            <el-menu-item index="/consultation">资讯中心</el-menu-item>
            <el-menu-item index="/about">关于扬海</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-menu>
        </el-col>
        <el-col :span="8">
          <div class="notice_btn_new">
            <el-button>我要还款 ⇀</el-button>
          </div>
        </el-col>
      </el-row>
    </div> -->
    <div class="introduceCer">
      <div class="introduceCer_box">
        <div class="introduceCer_box_top">
          <el-row>
            <el-col><span class="span1">业务介绍</span></el-col>
            <el-col><span class="span2">Business Introduction</span></el-col>
            <el-col><div class="introduceCer_box_top_border"></div></el-col>
          </el-row>
        </div>
        <div class="introduceCer_box_con">
          <el-row>
            <el-col :span="8"><img src="../../assets/img/1.png" alt=""></el-col>
            <el-col :span="14">
              <el-row>
                <el-col><span class="span1">01</span></el-col>
                <el-col><span class="span2">&nbsp;|</span></el-col>
                <el-col><span class="span3">什么是AMC？</span></el-col>
                <el-col><span class="span4">AMC（Asset management companies）即资产管理公司。凡是主要从事此类业务的机构或组织都可以称为资产管理公司（Asset management companies）。</span></el-col>
              </el-row>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="14">
              <el-row>
                <el-col><span class="span1">02</span></el-col>
                <el-col><span class="span2">&nbsp;|</span></el-col>
                <el-col><span class="span3">AMC的作用!</span></el-col>
                <el-col><span class="span4">金融是现代经济的核心，金融稳则经济稳。而AMC就是金融行业的稳定器，起到防控和化解金融风险的作用。</span></el-col>
              </el-row>
            </el-col>
            <el-col :span="8"><img src="../../assets/img/2.png" alt=""></el-col>
          </el-row>

          <el-row>
            <el-col :span="8"><img src="../../assets/img/3.png" alt=""></el-col>
            <el-col :span="14">
              <el-row>
                <el-col><span class="span1">03</span></el-col>
                <el-col><span class="span2">&nbsp;|</span></el-col>
                <el-col><span class="span3">扬海资产的职责</span></el-col>
                <el-col><span class="span4">自2017年以来我司极响应国家号召用实际行动化解坏账风险，落实银保监会的精神要求，主动承担资产公司化解金融风险、维护金融稳定的功能和职责。</span></el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="introduceBtm"><comFooter /></div>
  </div>
</template>
<script>
import comTop from "@/components/page/comTop.vue"; //头部
import comFooter from "@/components/page/comFooter.vue"; //脚部
import banner from "@/components/page/banner.vue"; //脚部
import comFooterMobile from "@/components/page/comFooterMobile.vue"; //脚部
export default {
  components: {
    comFooter,
    comTop,
    banner,
    comFooterMobile
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style>
@media screen and (min-width: 300px) and (max-width: 480px) {
 .index-introduce .introduceTop{
    display: none;
  }
  .index-introduce .introduceCer{
    display: none;
  }
  .index-introduce .introduceBtm{
    display: none;
  }
  .index-introduce .banner-box{
    display: block!important; 
  }
  .introduceCer_box_total{
    display: block!important; 
  }
  .introduceCer_box_top{
    padding: 40px 20px;
    background: #fff;
  }
  .introduceCer_box_top .span1{
    font-size:45px;
    font-family:Helvetica;
    color:rgba(34,34,34,1);
    line-height:45px;
  }
  .introduceCer_box_top .span2{
    font-size:20px;
    font-family:Helvetica;
    color:rgba(0,0,0,1);
    line-height:20px;
  } 
  .introduceCer_box_top .span3{
    width:350px;
    height:2px;
    background:rgba(34,34,34,1);
    margin-bottom: 100px;
  }
  .introduceCer_box_top .span4{
     margin-bottom: 10px;
  }
  .introduceCer_box_top .span4 img{
       width: inherit;
  }
  .introduceCer_box_top .span6{
       font-size: 80px;
       font-weight: bold;
  }
  .introduceCer_box_top .span7{
       font-weight: bold;
       font-size: 40px;
  }
 .introduceCer_box_top .span8{
    font-size:65px;
    font-family:Helvetica;
    color:rgba(34,34,34,1);
    line-height: 120px;
  }
  .introduceCer_box_top .span9{
    font-size:12px;
    font-family:Helvetica;
    color:#000000;
  }
}
.introduceCer_box_total{
  display: none;
}
.index-introduce .banner-box{
  display: none;
}
.index-introduce {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
    overflow: auto;
}
.introduceTop {
  height: 420px;
  background: url("./../../assets/img/yanghai_banner.png") no-repeat center
    center;
  background-size: 100% 100%;
}
.introduceCer{
  background: #fff;
}
.introduceCer_box_con img{
  width: 520px;
}
.introduceCer_box_con .el-row{
      padding-bottom: 170px;
}
.introduceCer_box_con .span1{
  font-size: 60px;
  color: #222222
}

.introduceCer_box_con .el-row .span2{
  font-size: 0.3rem!important;
    font-weight: bold;
    line-height:60px;
}
.introduceCer_box_con .el-row .span3{
font-size:45px;
font-family:MicrosoftYaHeiSemibold;
color:rgba(34,34,34,1);
height: 85px;
    display: inline-block;
    line-height: 85px;
}
.introduceCer_box_con .el-row .span4{
  font-size:18px;
font-family:MicrosoftYaHei;
color:rgba(0,0,0,1);
line-height:38px;
}
.introduceCer_box_top .span1{
  font-size:45px;
  font-family:MicrosoftYaHeiSemibold;
  color:rgba(34,34,34,1);
  line-height:45px;
}
.introduceCer_box_top .span2{
  font-size:20px;
  font-family:MicrosoftYaHei;
  color:rgba(0,0,0,1);
  line-height:20px;
  padding: 15px 0 40px 0;
  display: inline-block;
}
.introduceCer_box_top_border{
  width:350px;
  height:1px;
  background:rgba(34,34,34,1);
  margin-bottom: 100px;
}
.introduceCer_box{
  padding: 100px 0 0 260px;
}
.login-logos {
  text-align: center;
  padding: 45px 0 25px 80px;
  display: inline-block;
}
.login-logos img {
  background-size: cover;
  width: 314px;
  height: 50px;
  margin-bottom: 165px;
}
.menu_left_in .el-menu {
  border-right: none;
  background-color: transparent;
  padding-top: 45px;
}
.menu_left_in .el-menu .el-menu-item {
  color: #ffffff !important;
  font-size: 14px;
}
.el-menu-item.is-active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
.el-menu-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}
.menu_left_in .el-menu-item,
.el-submenu__title {
  font-size: 12px;
}
.menu_left_in .el-menu.el-menu--horizontal {
  border-bottom: none;
}
.notice_btn_new {
  position: absolute;
  top: 40px;
  right: 65px;
}
.notice_btn_new .el-button {
  background: transparent;
  color: #fff;
  width: 170px;
  height: 50px;
  border: 1px solid rgba(255, 255, 255, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/page/introduce.vue